"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphqlApi = void 0;
var graphql_request_1 = require("graphql-request");
var config_1 = require("../../config");
var GraphqlApi = /** @class */ (function () {
    /**
     * Create an instance of the APENFT API
     * @param config APIConfig for setting up the API, including an optional API key, network name, and base URL
     * @param logger Optional function for logging debug strings before and after requests are made
     */
    function GraphqlApi(config) {
        var _network = config.networkName;
        this.apiBaseUrl = config_1.API_BASE_URL[_network].apenftBaseApiUrl;
        this.chainId = config_1.CHAIN_ID[_network];
        this.appKey = config_1.API_BASE_URL[_network].key;
        this.appSecret = config_1.API_BASE_URL[_network].secret;
        this.account = config.account || '';
        if (!this.apiBaseUrl) {
            throw new Error("".concat(_network, " undefined api"));
        }
        this.chain = config_1.CHAIN[_network];
        this.walletChainId = "0x".concat(this.chainId.toString(16));
        this.networkName = _network;
        var getSign = this.getAPISign(_network);
        this.gqlClient = new graphql_request_1.GraphQLClient("".concat(this.apiBaseUrl, "/graphql"), { headers: __assign({}, getSign) });
    }
    GraphqlApi.prototype.getAPISign = function (_network) {
        var headers = {
            'x-chain-name': config_1.CHAIN[_network],
        };
        return headers;
    };
    GraphqlApi.prototype.blockChainRequest = function (_a) {
        var funcName = _a.funcName, gql = _a.gql, params = _a.params;
        var variables = __assign(__assign({}, params), { blockChain: {
                chain: this.chain,
                chainId: this.walletChainId
            } });
        return this.gqlClient.request(gql, variables);
    };
    GraphqlApi.prototype.putRequest = function (_a) {
        var funcName = _a.funcName, gql = _a.gql, params = _a.params;
        var variables = {
            input: __assign(__assign({}, params), { blockChain: {
                    chain: this.chain,
                    chainId: this.walletChainId
                } })
        };
        return this.gqlClient.request(gql, variables);
    };
    return GraphqlApi;
}());
exports.GraphqlApi = GraphqlApi;
